"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _default = exports.default = {
  name: 'Calendar',
  data: function data() {
    return {
      minDate: new Date(2008, 10, 1),
      calendarShow: false,
      startDate: undefined,
      endDate: undefined
    };
  },
  methods: {
    formatDate: function formatDate(date) {
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    },
    //确定
    onConfirm: function onConfirm() {
      var date = this.$refs.calendar.currentDate;
      this.startDate = this.formatDate(date[0]);
      this.endDate = this.formatDate(date[1]);
      this.$emit('dataRange', this.startDate, this.endDate);
      this.calendarShow = false;
    },
    //重置日期
    resetDate: function resetDate() {
      this.$refs.calendar.reset();
      this.startDate = undefined;
      this.endDate = undefined;
    }
  }
};